<template>
  <ZMainPage :loading="loading" type="card">
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">学生基础信息</span>
      </div>
      <el-form ref="form1" :model="form1" :rules="rules1" label-position="right" label-width="210rem">
        <el-row>
          <el-col span="8">
            <el-form-item label="学生姓名" prop="student_id">
              <el-select v-model="form1.student_id" filterable remote reserve-keyword placeholder="请输入学生关键字" @change="onStudentIdChange" :remote-method="remoteMethod" :loading="searchLoading">
                <el-option v-for="item in studentsList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="8">
            <el-form-item label="校区">
              <el-input v-model="form1.school_name" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="年级">
              <el-input v-model="form1.grade_name" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="行政班">
              <el-input v-model="form1.class_name" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">学生艺体信息</span>
      </div>
      <el-form ref="form2" :model="form2" :rules="rules2" label-position="right" label-width="220rem">
        <el-row>
          <el-col span="8">
            <el-form-item label="客户意向" prop="will">
              <el-select v-model="form2.will" placeholder="请选择">
                <el-option v-for="item in options.o1" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="艺体升学意愿评级" prop="level">
              <el-select v-model="form2.level" placeholder="请选择">
                <el-option v-for="item in options.o2" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="flex flex-wrap">
          <el-col span="8">
            <el-form-item label="家长支持度评级" prop="agree">
              <el-select v-model="form2.agree" placeholder="请选择">
                <el-option v-for="item in options.o3" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="预计系统学习时间" prop="study_time">
              <el-select v-model="form2.study_time" placeholder="请选择">
                <el-option v-for="item in options.o4" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="希望通过学校获取的支持" prop="school_support">
              <el-select v-model="form2.school_support" placeholder="请选择">
                <el-option v-for="item in options.o5" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="8" v-if="form2.school_support === '其他'">
            <el-form-item label="其他" prop="f6">
              <el-input v-model="form2.f6" maxlength="10" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="意向艺体方向" prop="yiti_way">
              <el-select v-model="form2.yiti_way" placeholder="请选择">
                <el-option v-for="item in options.o6" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="8" v-if="form2.yiti_way === '其他'">
            <el-form-item label="其他" prop="f8">
              <el-input v-model="form2.f8" maxlength="10" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="是否有相关学习或训练经历" prop="is_have_trained">
              <el-select v-model="form2.is_have_trained" placeholder="请选择">
                <el-option v-for="item in options.o7" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="是否参加过相关比赛/考级/展览" prop="is_attend_raced">
              <el-select v-model="form2.is_attend_raced" placeholder="请选择">
                <el-option v-for="item in options.o8" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="15">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="form2.remark" maxlength="300" placeholder="请输入" rows="8" show-word-limit type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template slot="footer">
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit">保存</el-button>
      <el-button :disabled="submitLoading" @click="handleBack">返回</el-button>
    </template>
  </ZMainPage>
</template>

<script>
import { validateNumber } from '@/utils/validate'
import http, { changeObjToArr } from '@/api'
import { formDataBackMixin } from '@/utils/mixins'
export default {
  _config: {"route":{"path":"add","meta":{"title":"新增"}}},
  mixins: [formDataBackMixin],
  data() {
    return {
      loading: false,
      searchLoading: false,
      submitLoading: false,
      form1: {
        student_id: '',
        school_name: '',
        grade_name: '',
        class_name: '',
      },
      rules1: {
        student_id: [{required: true, message: '请选择学生', trigger: 'change'}],
      },
      form2: {
        will: '',
        level: '',
        agree: '',
        study_time: '',
        school_support: '',
        f6: '',
        yiti_way: '',
        f8: '',
        is_have_trained: '',
        is_attend_raced: '',
        remark: '',
      },
      rules2: {
        will: [{ required: true, message: '请选择', trigger: 'change' }],
        level: [{ required: true, message: '请选择', trigger: 'change' }],
        agree: [{ required: true, message: '请选择', trigger: 'change' }],
        study_time: [{ required: true, message: '请选择', trigger: 'change' }],
        school_support: [{ required: true, message: '请选择', trigger: 'change' }],
        f6: [{ required: true, message: '请填写希望获取的支持', trigger: 'change' }],
        yiti_way: [{ required: true, message: '请选择', trigger: 'change' }],
        f8: [{ required: true, message: '请填写意向艺体方向', trigger: 'change' }],
        is_have_trained: [{ required: true, message: '请选择', trigger: 'change' }],
        is_attend_raced: [{ required: true, message: '请选择', trigger: 'change' }],
        remark: [{ required: true, message: '请输入', trigger: 'change' }],
      },
      studentsList: [],
      options: {
        o1: [],
        o2: [],
        o3: [],
        o4: [],
        o5: [],
        o6: [],
        o7: [],
        o8: [],
      }
    }
  },
  created() {
    this.getConfig()
  },
  methods: {
    getConfig() {
      this.loading = true
      http({ url: '/1v1/sys-config/get', pre: 'api2' }, { key: 'muti_study_follow' }).then(res => {
        const { yiti: data } = res
        this.options.o1 = changeObjToArr(data.will, true)
        this.options.o2 = changeObjToArr(data.level, true)
        this.options.o3 = changeObjToArr(data.agree, true)
        this.options.o4 = changeObjToArr(data.study_time, true)
        this.options.o5 = changeObjToArr(data.school_support)
        this.options.o6 = changeObjToArr(data.yiti_way)
        this.options.o7 = changeObjToArr(data.is_have_trained, true)
        this.options.o8 = changeObjToArr(data.is_attend_raced, true)
      }).finally(() => {
        this.loading = false
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.onSearch(query)
      } else {
        this.studentsList = []
      }
    },
    onSearch(student_name) {
      this.searchLoading = true
      http({url: '/work/muti-study-follow/search-student', pre: 'api2'}, { student_name }).then(res => {
        this.studentsList = res.map(item => ({
          value: item.student_id,
          label: item.student_name,
          school_name: item.school_name,
          grade_name: item.grade_name,
          class_name: item.class_name,
        }))
      })
      .finally(() => {
        this.searchLoading = false
      })
    },
    onStudentIdChange(val) {
      const obj = this.studentsList.find(item => item.value === val)
      this.form1.school_name = obj.school_name
      this.form1.grade_name = obj.grade_name
      this.form1.class_name = obj.class_name
    },
    handleSubmit() {
      this.$refs.form1.validate(valid1 => {
        this.$refs.form2.validate(valid2 => {
          if (valid1 && valid2) {
            const { school_support, f6, yiti_way, f8, ...other } = this.form2
            const data = { student_id: this.form1.student_id, school_support, yiti_way, ...other }
            if (school_support === '其他') {
              data.school_support = f6
            }
            if (yiti_way === '其他') {
              data.yiti_way = f8
            }
            console.log(data);
            this.submitLoading = true
            http({ url: '/work/muti-study-follow/add-yiti', method: 'post', pre: 'api2' }, data).then(() => {
              this.$message.success('保存成功')
              this.$router.back()
            }).finally(() => {
              this.submitLoading = false
            })
          }
        })
      })
    },
    handleBack() {
      this.formBack(this.form2)
    }
  }
}
</script>
